import store from "../redux/app/store";
import jwtDecode from "jwt-decode";

// Redux
import { logoutUser } from "../redux/features/userState/userStateSlice";
import {
  // setAppOpen,
  resetApplication,
} from "../redux/features/applicationState/applicationStateSlice";
import { resetPatient } from "../redux/features/patientState/patientStateSlice";

import toastManager from "../helpers/toastManager";

const logoutHandler = () => {
  store.dispatch(resetApplication());
  store.dispatch(logoutUser());
  store.dispatch(resetPatient());

  toastManager(
    "warning",
    "Authentication Token Expired",
    "Please enter username and password to confirm your identity."
  );
};

const handleValidationPrint = ({ decodedToken, isTokenExpired }) => {
  // Output to console token validity and expiration details.
  const expirationDate = new Date(0); // Initialize a new Date object to January 1, 1970 (Unix epoch)
  expirationDate.setSeconds(decodedToken.exp); // Set the seconds value to the expiration time
  const formattedExpirationDate = expirationDate.toLocaleString(); // Convert the date to a readable string

  // Calculate remaining token time
  const remainingTime = decodedToken.exp * 1000 - Date.now();

  const remainingDays = Math.floor(remainingTime / 1000 / 60 / 60 / 24);
  const remainingHours = Math.floor((remainingTime / 1000 / 60 / 60) % 24);
  const remainingMinutes = Math.floor((remainingTime / 1000 / 60) % 60);
  const remainingSeconds = Math.floor((remainingTime / 1000) % 60);

  if (isTokenExpired) {
    // Token has expired
    console.log(
      `TOKEN EXPIRED => Token Expiration: ${formattedExpirationDate} => REMAINING TIME: ${remainingDays} days, ${remainingHours} hours, ${remainingMinutes} minutes, ${remainingSeconds} seconds`
    );
  } else {
    // Token is still valid
    console.log(
      `TOKEN VALID => Token Expiration: ${formattedExpirationDate} => REMAINING TIME: ${remainingDays} days, ${remainingHours} hours, ${remainingMinutes} minutes, ${remainingSeconds} seconds`
    );
  }
};

const tokenVerification = () => {
  const storeData = store.getState();
  const userData = storeData.userState.userData;

  // Ensure the token is a non-empty string before trying to decode it
  const token = userData?.access;
  if (!token || typeof token !== "string") {
    logoutHandler();
    return false;
  }

  try {
    const decodedToken = jwtDecode(token);
    const isTokenExpired = Date.now() >= decodedToken.exp * 1000;

    // For debugging only
    // handleValidationPrint({
    //   decodedToken: decodedToken,
    //   isTokenExpired: isTokenExpired,
    // });

    if (isTokenExpired) {
      logoutHandler();
      return false;
    }

    return true;
  } catch (error) {
    // Handle the error (e.g., log it and/or logout the user)
    console.error("Error decoding token: ", error);
    logoutHandler();
    return false;
  }
};

export default tokenVerification;
